<div class="body ui container" fxLayout="column">

	<div fxLayout="row" fxLayoutAlign='space-between center' class="top">

		 <div>
				<span>Home</span>
				  <h2 class="ui primary header">Create an Account</h2>
		 </div>

	</div>
	<div class="ui divider" appMargin marginY="3"></div>

	<div fxLayout="row" fxLayoutGap='30px'>
	<div fxFlex="grow">
		
		
	<div class="ui padded segment no-border"  fxLayout="column"  appPadding="10" id="bg-color">
	<div appMargin marginB="10" >Company details you provided</div>
		
	<div fxFlex fxLayout="row" fxLayoutAlign="space-between start " appMargin marginB="10">
		<div fxFlex>
		<div class="sub-label">COMPANY OWNERSHIP TYPE</div>
		<div class="sub-value">Nigerian Owned</div>
	 </div>

	 <div fxFlex>
	 <div class="sub-label">COMPANY TYPE</div>
	 <div class="sub-value">Private Company Limited by Shares</div>
     </div>

    </div>


 	<div fxFlex fxLayout="row" fxLayoutAlign="space-between start" appMargin marginB="10">
	<div fxFlex>
	
	<div class="sub-label">COMAPNY RC/BN NUMBER</div>
	<div class="sub-value">861455</div>
 	</div>


 	<div fxFlex>

	<div class="sub-label">COMPANY TAX IDENTIFICATION NUMBER (TIN)</div>
	<div class="sub-value">05065899-0001</div>
	</div>

	  </div>
	
	</div>


	<div class="ui alert segment no-border" fxLayout="row" fxLayoutAlign="start center">

		<div fxFlex="7%">
			<i class="exclamation triangle  big colored primary icon"></i>
		</div>

		<div fxFlex>
			You are allowed a maximum of <strong>3 attempts.</strong> You have <strong>2 out of 3</strong> attempts left. If 
				you are unable to proceed with your registration, <strong class="text">click here</strong> to send us a message.
		</div>
	</div>

	<div class="ui segment  alert-2   no-border"   fxLayout="row" fxLayoutAlign="start center">
		<div fxFlex="7%">
			<i class="exclamation circle big colored primary icon"></i>
		</div>
		<div fxFlex  class="text">
			You have chosen to provide your details again.
		</div>
	
	</div>

	<div fxLayout="column" >
		<div fxFlex >
			<div class="sub-label">Company RC/BN Number</div>
			<div class="sub-value">861455</div>
			<span  >
				<svg width="92" height="24" viewBox="0 0 92 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<line x1="1" y1="23" x2="63" y2="23" stroke="#3F4395" stroke-width="2" stroke-linecap="round" stroke-dasharray="7 7"/>
					<path d="M90.7108 1.28932C89.8793 0.457875 88.774 0 87.5982 0C86.4225 0 85.3171 0.457875 84.4857 1.28928L72.1839 13.5911C72.0792 13.6957 72.0034 13.8257 71.9637 13.9683L70.0315 20.9102C69.9482 21.2096 70.0329 21.5307 70.2533 21.7499C70.4166 21.9123 70.6354 22 70.8594 22C70.9377 22 71.0167 21.9893 71.0942 21.9673L78.0361 19.9954C78.329 19.9122 78.556 19.6802 78.6328 19.3856C78.7097 19.0909 78.6248 18.7776 78.4099 18.562L74.0334 14.1723L84.2305 3.97508L88.0229 7.76742L80.2166 15.5525C79.8805 15.8876 79.8798 16.4317 80.2149 16.7678C80.5501 17.1039 81.0943 17.1046 81.4303 16.7695L90.7107 7.51433C91.5421 6.68293 92 5.57756 92 4.4018C92 3.22605 91.5421 2.12068 90.7108 1.28932ZM76.1615 18.7412L72.098 19.8954L73.2361 15.8068L76.1615 18.7412ZM89.4962 6.29814L89.2399 6.55377L85.4459 2.75975L85.7011 2.50461C86.2078 1.99783 86.8815 1.71875 87.5982 1.71875C88.3149 1.71875 88.9886 1.99783 89.4954 2.50465C90.0022 3.01138 90.2812 3.68513 90.2812 4.4018C90.2812 5.11848 90.0022 5.79223 89.4962 6.29814Z" fill="#3F4395"/>
					</svg>
			</span>
			</div >

			<div fxFlex appMargin marginY="5">
				<span><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M8 0.525024H14V5.33502C15.79 6.37502 17 8.30502 17 10.525C17 13.835 14.31 16.525 11 16.525C7.69 16.525 5 13.835 5 10.525C5 8.30502 6.21 6.37502 8 5.33502V0.525024ZM12 2.52502V6.48502L13 7.06502C14.24 7.78502 15 9.10502 15 10.525C15 12.735 13.21 14.525 11 14.525C8.79 14.525 7 12.735 7 10.525C7 9.10502 7.77 7.78502 9 7.06502L10 6.48502V2.52502H12ZM3 9.47502H0V11.475H3V9.47502ZM2.55 17.565L3.96 18.975L5.75 17.175L4.34 15.765L2.55 17.565ZM12 18.475V21.475H10V18.475H12ZM19 9.47502H22V11.475H19V9.47502ZM18.03 18.985L16.24 17.185L17.64 15.785L19.44 17.575L18.03 18.985Z" fill="black" fill-opacity="0.54"/>
				</svg>
				</span> 
				Click on the pencil icon to edit your RC/BN Number
			</div>


			<div fxFlex>
				
				<div class="sub-label">Company Tax Identification Number (TIN)</div>
				<div class="sub-value">05065899-0001</div>
				<span>
					<svg width="92" height="24" viewBox="0 0 92 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<line x1="1" y1="23" x2="63" y2="23" stroke="#3F4395" stroke-width="2" stroke-linecap="round" stroke-dasharray="7 7"/>
						<path d="M90.7108 1.28932C89.8793 0.457875 88.774 0 87.5982 0C86.4225 0 85.3171 0.457875 84.4857 1.28928L72.1839 13.5911C72.0792 13.6957 72.0034 13.8257 71.9637 13.9683L70.0315 20.9102C69.9482 21.2096 70.0329 21.5307 70.2533 21.7499C70.4166 21.9123 70.6354 22 70.8594 22C70.9377 22 71.0167 21.9893 71.0942 21.9673L78.0361 19.9954C78.329 19.9122 78.556 19.6802 78.6328 19.3856C78.7097 19.0909 78.6248 18.7776 78.4099 18.562L74.0334 14.1723L84.2305 3.97508L88.0229 7.76742L80.2166 15.5525C79.8805 15.8876 79.8798 16.4317 80.2149 16.7678C80.5501 17.1039 81.0943 17.1046 81.4303 16.7695L90.7107 7.51433C91.5421 6.68293 92 5.57756 92 4.4018C92 3.22605 91.5421 2.12068 90.7108 1.28932ZM76.1615 18.7412L72.098 19.8954L73.2361 15.8068L76.1615 18.7412ZM89.4962 6.29814L89.2399 6.55377L85.4459 2.75975L85.7011 2.50461C86.2078 1.99783 86.8815 1.71875 87.5982 1.71875C88.3149 1.71875 88.9886 1.99783 89.4954 2.50465C90.0022 3.01138 90.2812 3.68513 90.2812 4.4018C90.2812 5.11848 90.0022 5.79223 89.4962 6.29814Z" fill="#3F4395"/>
						</svg>
				</span>
				</div >

				<div fxFlex appMargin marginY="5">
					<span><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M8 0.525024H14V5.33502C15.79 6.37502 17 8.30502 17 10.525C17 13.835 14.31 16.525 11 16.525C7.69 16.525 5 13.835 5 10.525C5 8.30502 6.21 6.37502 8 5.33502V0.525024ZM12 2.52502V6.48502L13 7.06502C14.24 7.78502 15 9.10502 15 10.525C15 12.735 13.21 14.525 11 14.525C8.79 14.525 7 12.735 7 10.525C7 9.10502 7.77 7.78502 9 7.06502L10 6.48502V2.52502H12ZM3 9.47502H0V11.475H3V9.47502ZM2.55 17.565L3.96 18.975L5.75 17.175L4.34 15.765L2.55 17.565ZM12 18.475V21.475H10V18.475H12ZM19 9.47502H22V11.475H19V9.47502ZM18.03 18.985L16.24 17.185L17.64 15.785L19.44 17.575L18.03 18.985Z" fill="black" fill-opacity="0.54"/>
					</svg>
					</span> 
					Click on the pencil icon to edit your RC/BN Number
				</div>
		</div>
		<div class="ui  segment " fxLayout="row" fxLayoutAlign="space-between center" id="section" routerLink="/home-page/account/login">
			<div fxFlex>
					<i class="arrow right  colored primary icon"></i>
			</div>
			<div>
				<button class="ui primary button">Proceed</button>
			</div>
		</div>

		</div>

		
		<div fxFlex="30%" fxLayout="column"   >
			<div class="side" appPadding="7">
			<div appMargin marginB="4">
			<div class="sub-label">Nigerian Communications Commission</div>
			<div class="sub-value">Plot 423, Aguiyi Ironsi Street, Maitama, Abuja, Federal Capital Territory, Federal Republic of Nigeria.</div>
			 </div>
		
			<div appMargin marginB="4">
			<div class="sub-label">TEL</div>
			<div class="sub-value">+234-9-4617000</div>
			</div>
		
			<div appmargin marginB="4">
			<div class="sub-label">FAX</div>
			<div class="sub-value">+234-9-4617514</div>
			</div>
		
			 <div>
			 <div class="sub-label">EMAIL</div>
			 <div class="sub-vlaue">ncc@ncc.gov.ng</div>
			 </div>
			</div>

		 </div>
		 </div>

</div>

